import { SPACE_KEY } from 'constants/keyCodes';
import { CHECKBOX_STATUS } from './types';
import { StaticCheckbox } from './StaticCheckbox';

export type CheckboxProps = {
  /** True if the input is disabled */
  isDisabled?: boolean;
  /** Id of the Radio Button */
  id?: string;
  /** the id of the label for association */
  labelId?: string;
  /** Name of the input form control. Submitted with the form as part of a name/value pair. */
  name?: string;
  /** Function ran when the input is clicked */
  onClick?: (evt: KeyboardEvent | MouseEvent) => void;
  /** Current state the checkbox is in */
  status: CHECKBOX_STATUS;
  [otherOptions: string]: any;
};

/**
 * @deprecated
 * this checkbox implementation has been deprecated. please use ui/checkboxV2
 * */

export const Checkbox = ({
  isDisabled = false,
  id,
  labelId = '',
  name,
  onClick,
  status,
  ...props
}: CheckboxProps) => {
  const ariaProps: Record<string, any> = {
    'aria-checked': status,
    'aria-disabled': isDisabled,
  };
  if (name) {
    ariaProps['aria-label'] = name;
  } else if (labelId) {
    ariaProps['aria-labelledby'] = labelId;
  }

  return (
    <StaticCheckbox
      data-test="interactive-checkbox"
      id={id}
      isDisabled={isDisabled}
      name={name}
      onClick={isDisabled ? null : onClick}
      onKeyDown={(event: KeyboardEvent) => {
        if (event.keyCode === SPACE_KEY && !isDisabled && !!onClick) {
          onClick(event);
        }
      }}
      role="checkbox"
      status={status}
      tabIndex={0}
      {...ariaProps}
      {...props}
    />
  );
};

export default Checkbox;
